import $ from './jquery-global';
import 'paginationjs';
import cardsTmp from '../templates/eventCardsTpl';

export default function paginationCreate(items) {
  $('#pagination-container').pagination({
    pageSize: 20,
    showPrevious: false,
    showNext: false,
    dataSource: items,

    callback: function (data) {
      $('#data-container').html(cardsTmp(data));
    },
  });
}
